import Image from '2-core-elements/Image/Image';
import LinkCTA from '2-core-elements/LinkCTA/LinkCTA';
import { type FC, type PropsWithChildren } from 'react';

interface DataListItemProps {
    label: string;
    hideLabel?: boolean;
    value: string;
    hasActionButton?: boolean;
    onActionClick?: () => void;
}

interface DataListProps extends PropsWithChildren {
    variant?: 'default' | 'team';
}

const DataList = ({ children, variant = 'default' }: DataListProps): JSX.Element => {
    const listType = variant === 'team' ? 'data-list-team' : '';

    return (
        <dl className={`data-list ${listType}`}>
            {children}
        </dl>
    );
};

const DataListItem: FC<DataListItemProps> = ({ label, hideLabel = false, value, hasActionButton, onActionClick }) => {
    return (
        <div className="list-item">
            <dl className="list-item-content">
                {!hideLabel && <dt className="list-item-label">{label}</dt>}
                <dd className="list-item-value">{value}</dd>
            </dl>
            {hasActionButton && (
                <div className="list-item-tools">
                    <LinkCTA
                        size={'xs'}
                        suffixIcon={'edit'}
                        onClick={onActionClick}
                    >
                        Edit
                    </LinkCTA>
                </div>
            )}
        </div>
    );
};

interface DataListTeamItemProps {
    label: string;
    value?: string | null;
    logo?: string | null;
}

const DataListTeamItem: FC<DataListTeamItemProps> = ({ label, value, logo }) => {
    return (
        <div className="list-team-item">
            {logo ? (
                <div className="list-team-item-logo">
                    <Image
                        aspectRatio="1/1"
                        imgSrc={`${logo}`}
                        imgHeight={48}
                        imgWidth={48}
                        objectFit="contain"
                        imgAlt={`support-team-logo-${(value
                            ?.toLowerCase())
                            ?.split(' ')
                            .join('-')}`}
                    />
                </div>
            ) : (
                <div className="list-team-item-logo list-team-item-logo--no-selected" />
            )}
            <div className="list-team-item-title-wrapper">
                <div className="list-team-item-title">{label}</div>
                <div className="list-team-item-description">{value || 'No team selected'}</div>
            </div>
        </div>
    );
};

DataList.Item = DataListItem;

DataList.Team = DataListTeamItem;

export default DataList;
